import { useMemo } from "react";

import { GLDClosureTask } from "@nens/brostar/uploadapi-client";

import { getApi } from "@/api/api-configuration";
import { getFormObjectValues } from "@/helpers/helpers";
import { useAfterFormSubmit } from "@/hooks/use-after-form-submit";
import { BrostarForm, useBrostarFormDataStorage } from "@/libs/brostar-form";
import { GldClosureFormProps } from "@/types/form-types";

import { useGldUiSchema } from "../../schema/gld-ui-schema";

import { getGldClosureSchema } from "./schema/gld-closure-schema";

export function GldClosureForm(props: GldClosureFormProps) {
  const api = getApi();
  const afterSubmit = useAfterFormSubmit();
  const { type, oldUploadTask, task } = getFormObjectValues(props);

  const { formData, handleChange } = useBrostarFormDataStorage<GLDClosureTask>({
    key: "gldClosure",
    task,
  });

  const uiSchema = useGldUiSchema(formData?.metadata.qualityRegime);
  const schema = useMemo(() => getGldClosureSchema(type), [type]);

  const onSubmit = async () => {
    if (!formData) return;
    await api.createGldClosure(formData);
    if (oldUploadTask?.uuid) api.apiUploadtasksDelete({ uuid: oldUploadTask.uuid });
    await afterSubmit();
  };

  return (
    <BrostarForm
      schema={schema}
      uiSchema={uiSchema}
      formData={formData}
      onChange={handleChange}
      onSubmit={onSubmit}
      uploadTask={oldUploadTask}
    />
  );
}
